import { render } from "./SubmitView.vue?vue&type=template&id=23162c94"
import script from "./SubmitView.vue?vue&type=script&lang=js"
export * from "./SubmitView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__